import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_bfbbdcd337547f833b6c9d1ee8e84b08_721126cf.jpg"
          alt="Heavy equipment land clearing in Tennessee"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/75" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 lg:px-12 flex flex-col items-center">
        <p className="font-heading text-brand-green-accent text-sm tracking-[0.4em] uppercase mb-4">
          NORTHEAST TENNESSEE - NATIONWIDE SERVICE
        </p>
        <h1 className="font-heading font-800 text-white text-6xl md:text-8xl lg:text-9xl tracking-widest uppercase leading-none mb-4">
          Holston Land<br />Management
        </h1>
        <p className="font-heading font-500 text-gray-300 text-xl md:text-3xl tracking-[0.2em] uppercase mb-8">
          Professional Land Services
        </p>
        <div className="w-16 h-0.5 bg-brand-green-accent mx-auto mb-8" />
        <p className="font-body text-gray-300 text-base md:text-lg max-w-2xl leading-relaxed mb-10">
          We provide professional services ranging from excavation and grading to forestry mulching and land clearing, full site preparation to demolition, and property maintenance to food plot development. Our experience covers it all.
        </p>
        <div className="flex flex-wrap gap-4 items-center justify-center">
          <Link
            to="/contact"
            className="px-8 py-4 bg-brand-green hover:bg-brand-green-mid font-heading font-700 text-white text-lg tracking-widest uppercase cursor-pointer whitespace-nowrap transition-colors rounded-sm"
          >
            Get a Free Quote
          </Link>
          <Link
            to="/services"
            className="px-8 py-4 border border-white/40 hover:border-white font-heading font-700 text-white text-lg tracking-widest uppercase cursor-pointer whitespace-nowrap transition-colors rounded-sm"
          >
            Our Services
          </Link>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
        <div className="w-px h-12 bg-white/30" />
        <span className="font-body text-xs text-white/40 tracking-widest uppercase">Scroll</span>
      </div>
    </section>
  );
}
